module.exports = __webpack_public_path__ + "static/media/Sarah S.514d32ff.png";